import { ReactNode } from 'react';

interface ErrorMessageProps {
  title?: string;
  message: string;
  action?: ReactNode;
  variant?: 'error' | 'warning' | 'info';
}

export const ErrorMessage = ({ 
  title = 'Error', 
  message, 
  action,
  variant = 'error' 
}: ErrorMessageProps) => {
  const variantStyles = {
    error: 'border-red-200 bg-red-50 text-red-800',
    warning: 'border-yellow-200 bg-yellow-50 text-yellow-800',
    info: 'border-blue-200 bg-blue-50 text-blue-800',
  };

  const iconStyles = {
    error: '❌',
    warning: '⚠️',
    info: 'ℹ️',
  };

  return (
    <div className={`border rounded-lg p-4 ${variantStyles[variant]}`}>
      <div className="flex items-start space-x-3">
        <span className="text-xl">{iconStyles[variant]}</span>
        <div className="flex-1">
          <h3 className="font-medium text-sm mb-1">{title}</h3>
          <p className="text-sm">{message}</p>
          {action && (
            <div className="mt-3">
              {action}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};